module.exports = __webpack_public_path__ + "media/A.0b915efc.mp4";